module.exports = __webpack_public_path__ + "media/images/icon_a10_blue-4442d8fc85ef0135c56fe77eb5150242.png";